import { ThemeOptions } from '@mui/material';

import { black, red, white, gray } from '~/styles/colors';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    severity0: true;
    severity1: true;
    severity2: true;
    severity3: true;
    severity4: true;
    severity5: true;
  }
}

const ChipTheme: ThemeOptions['components'] = {
  MuiChip: {
    defaultProps: {
      size: 'medium',
      color: 'default',
    },
    styleOverrides: {
      outlined: ({ theme }) => ({
        fontWeight: 300,
        '&.MuiChip-colorDefault': {
          backgroundColor: white,
        },
        '&.MuiChip-colorError': {
          backgroundColor: theme.palette.error.light,
        },
        '&.MuiChip-colorInfo': {
          backgroundColor: theme.palette.info.light,
        },
        '&.MuiChip-colorPrimary': {
          backgroundColor: theme.palette.primary.light,
        },
        '&.MuiChip-colorSuccess': {
          backgroundColor: theme.palette.success.light,
        },
        '&.MuiChip-colorWarning': {
          backgroundColor: theme.palette.warning.light,
          '.MuiChip-label': {
            color: theme.palette.primary.main,
          },
        },
        '& .MuiChip-iconColorDefault': {
          color: black[500],
        },
        border: `1px solid ${black[200]}`,
        borderRadius: '100px',
      }),
      filled: ({ theme }) => ({
        fontWeight: 400,
        '&.MuiChip-colorDefault': {
          background: black[100],
        },
        '&.MuiChip-colorInfo': {
          backgroundColor: theme.palette.info.dark,
        },
        '&.MuiChip-colorSuccess': {
          backgroundColor: theme.palette.success.dark,
        },
        '&.MuiChip-colorWarning': {
          backgroundColor: theme.palette.warning.dark,
        },
        '& .MuiChip-iconColorDefault': {
          color: gray[600],
        },
      }),
      sizeSmall: {
        padding: '5px',
        fontSize: '14px',
      },
      sizeMedium: {
        fontSize: 16,
        '& .MuiChip-icon': {
          fontSize: 20,
        },
      },
    },
    variants: [
      {
        props: { variant: 'severity0' },
        style: {
          backgroundColor: black[100],
        },
      },
      {
        props: { variant: 'severity1' },
        style: {
          backgroundColor: red.A50,
        },
      },
      {
        props: { variant: 'severity2' },
        style: {
          backgroundColor: red[100],
        },
      },
      {
        props: { variant: 'severity3' },
        style: {
          backgroundColor: red[300],
          '& .MuiChip-label': {
            color: white,
          },
        },
      },
      {
        props: { variant: 'severity4' },
        style: {
          backgroundColor: red[500],
          '& .MuiChip-label': {
            color: white,
          },
        },
      },
      {
        props: { variant: 'severity5' },
        style: {
          backgroundColor: red[700],
          '& .MuiChip-label': {
            color: white,
          },
        },
      },
    ],
  },
};

export default ChipTheme;
